import $ from 'jquery';
import './src/jquery.cookie';
import './src/jquery.cycle2.min';
import './src/jquery.cycle2.carousel.min';
import './src/common';
import './src/cart/cart';
import './src/checkout/checkout';

import '../assets/img/logo.png';

import '../assets/img/favicons/favicon-16x16.png';
import '../assets/img/obagiforlife.png';
import '../assets/img/pages/delivery/pickup.jpg';
import '../assets/img/pages/delivery/np.png';
import '../assets/img/pages/payment/payment.png';
import '../assets/img/pages/payment/privatbank.jpg';
import '../assets/img/pages/certificate/certificate_obagi_1_thumb.png';
import '../assets/img/pages/certificate/certificate_obagi_2_thumb.png';
import '../assets/img/pages/certificate/certificate_obagi_3_thumb.png';
import '../assets/img/pages/certificate/certificate_obagi_4_thumb.png';

// import '../assets/img/logo_obagi.png';


// import SentryService from './src/common/service/sentry.js';
// SentryService.init(env, sentryDsn);



window.addEventListener('load', () => {
  // init_map();
  // $.initSlider();
});



// WEBPACK FOOTER //
// ./frontend/index.js